import { View, ViewDensity, ViewType } from "@common/types/views/views";
import { TransferRuleDetailsColumn } from "./transferHistoryRuleDetailsTableViewConfig";

export const defaultTransferHistoryRuleDetailsView: View = {
    type: ViewType.HISTORY_RULE_DETAILS,
    columns: [
        { id: TransferRuleDetailsColumn.TIME },
        { id: TransferRuleDetailsColumn.GROUP },
        { id: TransferRuleDetailsColumn.FROM },
        { id: TransferRuleDetailsColumn.TO },
        { id: TransferRuleDetailsColumn.ACTIONS },
        {
            id: TransferRuleDetailsColumn.EDIT,
            options: { pin: "right" },
        },
    ],
    filters: {},
    options: {
        selection: true,
        density: ViewDensity.MD,
    },
};
